



const ReactProject = () => {
    return (
        <p> Hello from ReactProject! </p>
    )
}

export default ReactProject;